import React from 'react';
import { StatusFeedback } from '../../../../components/core';
import { IconAlertCircle } from '../../../../components/icons/IconAlertCircle';

export const SurveyErrorFallback = (): JSX.Element => (
  <StatusFeedback.danger Icon={IconAlertCircle} testID="survey-error-feedback">
    Something unexpected happened. Please try again later.
  </StatusFeedback.danger>
);
